import Swal from "sweetalert2";
import { deleteReplyOnMessage } from "../../apis";
import useReplies from "./useReplies";

const DeleteReplyForAdmin = ({
  currentMessageId,
  setDropdownIndex,
  data,
  setRepliesData,
  setPagination,
}) => {
  const { fetchReplies } = useReplies();

  const handleDeleteReply = (replyId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This reply will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: () => {
        return deleteReplyOnMessage(replyId)
          .then((response) => {
            return response.data;
          })
          .catch((error) => {
            Swal.showValidationMessage(
              error?.response?.data?.message ||
                error.message ||
                "Failed to delete the reply"
            );
            console.error("Error deleting reply:", error);
          });
      },
    })
      .then((result) => {
        if (result.isConfirmed) {
          Swal.fire("Deleted!", "The reply has been deleted.", "success");

          fetchReplies({
            messageId: currentMessageId,
            scrollToBottom: true,
          }).then((result) => {
            if (result) {
              const { repliesData, pagination } = result;
              setRepliesData(repliesData);
              setPagination(pagination);
            }
          });
        }
      })
      .finally(() => {
        setDropdownIndex(null);
      });
  };

  return (
    <button
      className="tw-w-full hover:tw-bg-red-500 hover:tw-text-white tw-text-left tw-px-3 tw-py-1"
      onClick={() => handleDeleteReply(data.id)}
    >
      Delete
    </button>
  );
};

export default DeleteReplyForAdmin;
